import { FileUpdateInput } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFileMutationDocument } from "./file.gql";

export interface UseUpdateFileProps {
  id: string;
  ownerId: string;
  ownerType: string;
  onCompleted?: () => void;
  onError?: (e: Error) => void;
}

export const useUpdateFile = ({ id, ownerId, ownerType, onCompleted, onError }: UseUpdateFileProps) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (input: FileUpdateInput) => {
      const client = createOperationClient("updateFile");
      return await client.request(updateFileMutationDocument, { input });
    },
    onSuccess: () => {
      // Invalidate file queries
      queryClient.invalidateQueries({
        queryKey: queryKeys.files.list(ownerId, ownerType),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.files.detail(id),
      });

      if (onCompleted) {
        onCompleted();
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return {
    updateFile: mutation.mutate,
    queryResult: mutation,
    loading: mutation.isPending,
  };
};
